<template>
  <v-main>

    <v-container
        id="add-user-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-logout"
          class="px-5 py-3"
          ref="form"
      >

        <div data-cy="logout-error">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>


      </base-material-card>

    </v-container>
  </v-main>
</template>

<script>
import {mapMutations} from "vuex";
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'

export default {
  name: "CoreLogoutView",
  components: {
    SharedPageMessages
  },
  created() {
    this.setAuthorization(null)
    this.successMessages.push('You have logged out of your account successfully.')
  },
  methods: {
    ...mapMutations({
      setAuthorization: 'setAuthorization',
    }),
  },
  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: []
    }
  }
}

</script>
